<template>
    <div class="text-xs-center">
        <v-menu v-model="menu" class="hundred-percent-width"
        :close-on-content-click="false"
        :close-on-click="false"
        :nudge-width="100"
        >
        <template v-slot:activator="{ on }">
            <v-btn class="trimmed-button hundred-percent-width"
            v-on="on"
            flat
            :disabled="disabled"
            >
            <v-icon dark>airline_seat_recline_extra</v-icon>
            {{menuText}}
            <v-icon dark>arrow_drop_down</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-list>
                <v-list-tile v-for="(passengerType,index) in passengerTypes" :key="index">
                    <PassengerSelector
                        :setCount="getSetPassengerCountByPax(index)"
                        :Icon="passengerType.icon"
                        :Description="passengerType.description"
                        @passengerCount="c=>passengerType.count=c"
                    />             
                </v-list-tile>                                                   
            </v-list>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-layout row>
                    <v-flex md6>
                        <v-btn-toggle flat>
                            <v-btn flat icon small @click="selectPreviousSeatClass()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
                            <div style="text-align:center;width:80px;padding-top:3px;"><span>{{seatClasses[selectedSeatClassIndex].text}}</span></div>
                            <v-btn flat icon small @click="selectNextSeatClass()"><v-icon>keyboard_arrow_right</v-icon></v-btn>
                        </v-btn-toggle>
                    </v-flex>
                    <v-flex md6 class="text-md-right text-xs-right pl-2">
                        <v-btn color="primary" flat @click="clickOkBtn()">OK</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
        </v-menu>
    </div>               
</template>

<script>
import PassengerSelector from './PassengerSelector'
export default {
    props:['setPassengerCountByPax','disabled',],
    created(){
        if (this.setPassengerCountByPax!=null){
            setTimeout(()=>{
                this.getPassengerCount();
            },1000);
            
        }
        setTimeout(() => {
          this.clickOkBtn();
        },2500);        
    },
    updated(){
        if (this.setPassengerCountByPax!=null){
            setTimeout(()=>{
                this.getPassengerCount();
            },1000);
            
        }        
    },
    components:{
        PassengerSelector
    },
    data(){
        return {
            menu:false,
            passengerTypes:[
                {icon:"group", description:"Adults", count:0},
                {icon:"child_care", description:"Children", count:0},
                {icon:"child_friendly", description:"Infants", count:0},
                {icon:"school", description:"Students", count:0}
            ],
            seatClasses:[
                {text:'Economy', value:'Y'},
                {text:'Business', value:'C'},
                {text:'First', value:'F'}
            ],
            selectedSeatClassIndex:0,
            menuText:"Passengers"
        }
    },
    methods:{
        getSetPassengerCountByPax(index){
            let keys = ["adult","child","infant", "student"];
            return this.setPassengerCountByPax[keys[index]];
        },
        selectPreviousSeatClass(){
            if (this.selectedSeatClassIndex>0)
            this.selectedSeatClassIndex--;
        },
        selectNextSeatClass(){
            if (this.selectedSeatClassIndex<2)
            this.selectedSeatClassIndex++;
        },
        getPassengerCount(){
            var totalCount = this.passengerTypes[0].count+
              this.passengerTypes[1].count+ 
              this.passengerTypes[2].count+
              this.passengerTypes[3].count;
            var passengerCounts = {
                adt:this.passengerTypes[0].count,
                cnn:this.passengerTypes[1].count,
                inf:this.passengerTypes[2].count,
                stu:this.passengerTypes[3].count,
                total:totalCount
            }
            this.menuText = totalCount==0? "Passengers":this.seatClasses[this.selectedSeatClassIndex].text + " (" + totalCount + ")";
            this.$emit('passengerCounts',passengerCounts);
        },
        clickOkBtn(){
            this.getPassengerCount();
            this.$emit('seatClassSelected', this.seatClasses[this.selectedSeatClassIndex].value);
            this.menu=false;
        }
    }
}
</script>

<style>
.hundred-percent-width{
    width: 100%;
}
.trimmed-button{
    margin-left: 0px;
    margin-right: 0px;
}
.number-of-passenger{
    width:100%;
    text-align: center;
}
</style>
